import { __module as t } from "../../../_virtual/isISO8601.js";
import { a as d } from "./util/assertString.js";
Object.defineProperty(e = t.exports, "__esModule", {
  value: !0
}), e.default = function (t) {
  var d = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  (0, r.default)(t);
  var e = d.strictSeparator ? o.test(t) : a.test(t);
  return e && d.strict ? s(t) : e;
}, r = d && d.__esModule ? d : {
  default: d
}, a = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, o = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, s = function s(t) {
  var d = t.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
  if (d) {
    var e = Number(d[1]),
      r = Number(d[2]);
    return e % 4 == 0 && e % 100 != 0 || e % 400 == 0 ? r <= 366 : r <= 365;
  }
  var a = t.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number),
    o = a[1],
    s = a[2],
    u = a[3],
    c = s ? "0".concat(s).slice(-2) : s,
    i = u ? "0".concat(u).slice(-2) : u,
    l = new Date("".concat(o, "-").concat(c || "01", "-").concat(i || "01"));
  return !s || !u || l.getUTCFullYear() === o && l.getUTCMonth() + 1 === s && l.getUTCDate() === u;
}, t.exports = e.default, t.exports.default = e.default;
var e,
  r,
  a,
  o,
  s,
  u = t.exports;
export { u as i };